import { useId, type ReactNode } from 'react';
import styles from './Slider.module.css';

interface SliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  format: (value: number) => string;
  onChange: (value: number) => void;
}

export function Slider({ label, value, min, max, step = 1, format, onChange }: SliderProps) {
  const id = useId();
  return (
    <div className={styles.row}>
      <label className={styles.label} htmlFor={id}>
        <span className={styles.name}>{label}</span>
        <span className={styles.value}>{format(value)}</span>
      </label>
      <input
        id={id}
        className={styles.input}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={e => onChange(Number(e.target.value))}
      />
    </div>
  );
}

export function Row({ children }: { children: ReactNode }) {
  return <div className={styles.row}>{children}</div>;
}

export function RowLabel({ name, value }: { name: string; value?: string }) {
  return (
    <div className={styles.label}>
      <span className={styles.name}>{name}</span>
      {value ? <span className={styles.value}>{value}</span> : <span />}
    </div>
  );
}
